
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PhoneCall, ChevronRight } from 'lucide-react';

const ServicesHeader: React.FC = () => {
  return (
    <section className="pt-32 pb-20 bg-gradient-to-b from-pkgreen-100/80 to-white relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-pkgreen-600 font-display uppercase tracking-wider text-sm mb-2 block animate-fade-up">
            What We Offer
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 text-gray-900 animate-fade-up">
            Our Services
          </h1>
          <p className="text-xl text-gray-700 animate-fade-up mb-8">
            Comprehensive landscape services for residential and commercial properties
            throughout Fairfield County, Connecticut.
          </p>
          <div className="flex justify-center space-x-4 animate-fade-up">
            <Button asChild size="lg" className="bg-pkgreen-600 hover:bg-pkgreen-700">
              <a href="#contact-section">
                <PhoneCall className="mr-2 h-4 w-4" />
                Request a Quote
              </a>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-pkgreen-600 text-pkgreen-600 hover:bg-pkgreen-50">
              <Link to="/portfolio">
                View Our Work
                <ChevronRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHeader;
